import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { CheckinService } from 'src/app/services/checkin.service';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { ToastMachineService } from 'src/app/services/toast-machine.service';

@Component({
  selector: 'app-check-in',
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.scss']
})
export class CheckInComponent implements OnInit, ViewWillEnter, OnDestroy {

  checkInForm: FormGroup[] = [];

  processing = false;
  kvkk = false;
  terms = false;

  maxTime: string = dayjs(new Date().toISOString()).add(-18, 'year').toISOString();

  constructor(
    private mdlCtrl: ModalController,
    public dataServ: DataService,
    private fb: FormBuilder,
    private checkinServ: CheckinService,
    private translator: GetTranslationService,
    private toaster: ToastMachineService,
    private authServ: AuthService,
    public modalServ: ModalMakerService,
    private router: Router,
    private analytics: AnalyticsService,
    private titleService: Title
  ) { }

  async ngOnInit() {
    this.authServ.control();

    if (this.authServ.isLogged) {
      await this.authServ.getMe();
    }
    this.addPerson();
  }

  ionViewWillEnter(): void {
    this.titleService.setTitle('Check-in');
  }

  ngOnDestroy(): void {
    this.titleService.setTitle('Home');
  }

  addPerson() {
    this.checkInForm.push(this.fb.group({
      name: [this.authServ.profile ? this.authServ.profile.first_name : '', [Validators.required]],
      surname: [this.authServ.profile ? this.authServ.profile.last_name : '', [Validators.required]],
      checkin: [new Date(), [Validators.required]],
      checkout: [new Date(), [Validators.required]],
      email: [this.authServ.profile ? this.authServ.profile.e_mail : '', [Validators.required]],
      birthdate: [this.authServ.profile ? this.authServ.profile.date_of_birth : '', [Validators.required]],
      phone: [this.authServ.profile ? this.authServ.profile.phone_no : ''],
      idno: [this.authServ.profile ? this.authServ.profile.id_no : ''],
      vehicleno: [this.authServ.profile ? this.authServ.profile.vehicle_no : ''],
      address: [this.authServ.profile ? this.authServ.profile.address : '', [Validators.required]],
      city: [this.authServ.profile ? this.authServ.profile.city : '', [Validators.required]],
      country: [this.authServ.profile ? this.authServ.profile.country : '', [Validators.required]],
      gender: [this.authServ.profile ? this.authServ.profile.gender : 'male', [Validators.required]],
      allergies: [this.authServ.profile ? this.authServ.profile.allergy : false],
      alleryDesc: [this.authServ.profile ? this.authServ.profile.allergy_description : ''],
      signature: [this.authServ.profile ? this.authServ.profile.signature : ''],
      passportFront: [''],
      passportBack: [''],
      invoiceInf: [this.authServ.profile ? this.authServ.profile.invoice_info : false],
      companyName: [this.authServ.profile ? this.authServ.profile.company_name : ''],
      staffName: [this.authServ.profile ? this.authServ.profile.staff_name : ''],
      idNo: [this.authServ.profile ? this.authServ.profile.invoice_id_no : ''],
      taxArea: [this.authServ.profile ? this.authServ.profile.tax_area : ''],
      taxNo: [this.authServ.profile ? this.authServ.profile.tax_no : ''],
      companyAddress: [this.authServ.profile ? this.authServ.profile.company_address : ''],
      companyEmail: [this.authServ.profile ? this.authServ.profile.invoice_mail : ''],
    }));

    this.analytics.eventEmitter('checkin_add_person', 'check-in', 'click');
  }

  uploadPhoto(file: File, type: string, form: FormGroup) {
    const READER = new FileReader();

    READER.onload = () => {
      const base64String = READER.result;

      if (type === 'front') {
        form.controls.passportFront.setValue(base64String);
      } else {
        form.controls.passportBack.setValue(base64String);
      }
    };

    READER.readAsDataURL(file);
  }

  async close() {
    await this.mdlCtrl.dismiss();
  }

  async checkin() {
    this.processing = true;
    for (const form of this.checkInForm) {

      if (form.invalid) {
        const MSG = await this.translator.getTranslate('Please fill the form');
        this.toaster.toastMachine(MSG, 'danger', 3000);
        this.processing = false;
        return null;
      }
    }

    try {
      await this.checkinServ.checkIn(this.checkInForm);

      this.analytics.eventEmitter('checkin_success', 'check-in', 'click');

      if (this.dataServ.rData.upsell_item_id) {
        this.router.navigateByUrl('/home/116/' + this.dataServ.rData.upsell_item_id);
      }
      this.close();
    } catch { }

    this.processing = false;

  }
}
